<template>
	<PortalHeaderNavMobileGeneric
		:is-open="navigationStore.isMobileProfileMenuOpen"
		variant="right"
		@update:is-open="navigationStore.setIsMobileProfileMenuOpen($event)"
	>
		<template #header>
			<NuxtLink to="/perfil">
				<PortalHeaderNavProfileOption variant="mobile" bg-variant="primary" />
			</NuxtLink>
		</template>
		<template #content>
			<section class="flex flex-col items-start justify-between pt-2">
				<div class="relative">
					<PortalHeaderNavMobileOptionLink
						v-if="profileOptions?.[0]"
						:option="profileOptions[0]"
						class="w-full px-5 py-[13.5px]"
					/>
					<span
						v-if="!user?.hasCompletedRegistration"
						class="absolute inset-y-0 right-1 my-auto size-2 rounded-full bg-tertiary"
					/>
				</div>
			</section>
		</template>
		<template #footer>
			<PortalHeaderNavLogoutButton @logout="handleLogout" />
		</template>
	</PortalHeaderNavMobileGeneric>
</template>

<script setup lang="ts">
import { useNavigationStore } from '~/store/navigationStore';
import { profileOptions } from '.';

const { clear, user } = useUserSession();
const navigationStore = useNavigationStore();

function handleLogout() {
	clear();
	navigationStore.setIsMobileProfileMenuOpen(false);
}
</script>
